import { render, staticRenderFns } from "./LoginNotice.vue?vue&type=template&id=79177ebe"
import script from "./LoginNotice.vue?vue&type=script&lang=js"
export * from "./LoginNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports